import { observable, action, computed, runInAction, flow, toJS, set } from 'mobx';
import { ListView } from 'antd-mobile';

import Serv from './DetailedListServ';

// dataSource 数据
const getSectionData = (dataBlob, sectionId) => dataBlob[sectionId];
const getRowData = (dataBlob, sectionId, rowId) => dataBlob[rowId];
let dataSource = new ListView.DataSource({
  getRowData,
  getSectionHeaderData: getSectionData,
  rowHasChanged: (row1, row2) => row1 !== row2,
  sectionHeaderHasChanged: (s1, s2) => s1 !== s2
});

// // 时间戳转年月日星期
// let formatTime = timeStamp => {
//   let addZero = val => (val < 10 ? `0${val}` : val);
//   let time = new Date(+timeStamp);
//   return `${time.getFullYear()}.${addZero(time.getMonth() + 1)}.${addZero(
//     time.getDate()
//   )} 星期${'日一二三四五六'.charAt(time.getDay())}`;
// };

class DetailedListMod {
  // 当前页数
  @observable pageNum = 0;

  // 每页数量
  @observable pageSize = 20;

  // 是否正在加载
  @observable loading = false;

  // 是否还有更多
  @observable end = false;

  // 筛选条件
  @observable filter = 2; // 默认显示待办

  // 显示筛选框
  @observable showFilter = false;

  // 日程列表
  // @observable rawTaskList = [];

  @observable taskMap = {};

  @observable dataSource = dataSource;

  @action
  changeState(key, value) {
    this[key] = value;
  }

  @action
  clearData() {
    this.pageNum = 0;
    this.pageSize = 20;
    this.loading = false;
    this.end = false;
    this.taskMap = {};
    this.dataSource = dataSource;
  }

  // 获取日程清单列表
  getTaskList = flow(function* (isReload = false, extend = {}) {
    try {
      // 重新开始分页，全部置为初始状态
      if (isReload) {
        this.pageNum = 0;
        this.taskMap = {};
        this.end = false;
      }
      // 如果正在加载，或者没有更多了，则停止分页请求
      if (this.loading || this.end) return;
      this.loading = true;

      let params = {
        pageNum: this.pageNum + 1,
        pageSize: this.pageSize
      };
      // 如有筛选，则根据筛选条件做请求
      if (this.filter != 0) {
        params.status = this.filter;
      }
      // 如果是搜索筛选，则不带状态
      if (extend && extend.title) {
        delete params.status;
      }
      params = Object.assign(params, extend);
      const { data } = yield Serv.getTaskList(params);
      this.loading = false;
      if (data && Array.isArray(data.list) && data.list[0]) {
        this.taskMap = Object.assign({}, this.taskMap, data.list[0].map);
        this.pageNum += 1;
        this.end = this.pageSize * this.pageNum >= data.total;
      }
    } catch (error) {
      this.loading = false;
    }
  });

  // 修改指定日程状态
  alterTaskStatus = flow(function* (id, status) {
    try {
      const params = {
        agendaId: id,
        status
      };
      const { data } = yield Serv.alterTaskStatus(params);
      // 修改成功，下面找到该条记录，将其置为相应状态
      let taskMap = JSON.parse(JSON.stringify(this.taskMap));
      Object.keys(taskMap).forEach((_key) => {
        taskMap[_key].forEach((_val, _index) => {
          if (_val.subId == id) {
            taskMap[_key][_index].status = status;
          }
        });
      });
      this.taskMap = taskMap;
    } catch (error) {}
  });

  // 被filter条件过滤过的rawTaskList
  // @computed get filteredTaskList() {
  //   const { filter, rawTaskList } = this;
  //   if (filter == 0) return rawTaskList;
  //   return rawTaskList.filter(_val => {
  //     return _val.status == filter - 1;
  //   });
  // }
  // @computed get filteredTaskList() {
  //   const { filter, taskMap } = this;
  //   if (filter == 0) return taskMap;
  //   let newTaskMap = {};
  //   return Object.keys(taskMap).forEach(_key => {
  //     newTaskMap[_key] = [];
  //     taskMap[_key].forEach((_item) => {
  //       if(_item.status == filter - 1)
  //     })
  //   })
  //   return rawTaskList.filter(_val => {
  //     return _val.status == filter - 1;
  //   });
  // }

  // 将原始数据处理为 ListView 需要的格式 (即拥有数据的dataSource)
  // @computed get taskList() {
  //   if (this.filteredTaskList.length == 0) return '';

  //   let dataBlob = {};
  //   let sectionIds = [];
  //   let rowIds = [];

  //   this.filteredTaskList.forEach(_val => {
  //     let title = formatTime(_val.date);
  //     if (!dataBlob[title]) {
  //       dataBlob[title] = [];
  //       sectionIds.push(title);
  //       rowIds[rowIds.length] = [];
  //     }
  //     dataBlob[title].push(_val);
  //     rowIds[rowIds.length - 1].push(rowIds[rowIds.length - 1].length);
  //   });

  //   let dataSource = this.dataSource.cloneWithRowsAndSections(dataBlob, sectionIds, rowIds);
  //   return dataSource;
  // }
  @computed get taskList() {
    if (Object.keys(this.taskMap).length == 0) return '';

    let dataBlob = {};
    let sectionIds = [];
    let rowIds = [];

    Object.keys(this.taskMap).forEach((_key) => {
      dataBlob[_key] = _key;
      sectionIds.push(_key);
      rowIds[rowIds.length] = [];
      this.taskMap[_key].forEach((_item) => {
        dataBlob[_item.subId] = _item;
        rowIds[rowIds.length - 1].push(_item.subId);
      });
    });

    // this.filteredTaskList.forEach(_val => {
    //   let title = formatTime(_val.date);
    //   if (!dataBlob[title]) {
    //     dataBlob[title] = [];
    //     sectionIds.push(title);
    //     rowIds[rowIds.length] = [];
    //   }
    //   dataBlob[title].push(_val);
    //   rowIds[rowIds.length - 1].push(rowIds[rowIds.length - 1].length);
    // });

    let dataSource = this.dataSource.cloneWithRowsAndSections(dataBlob, sectionIds, rowIds);
    return dataSource;
  }
}
const detailedListMod = new DetailedListMod();
export default detailedListMod;



// WEBPACK FOOTER //
// ./src/pages/Promote/Schedule/DetailedList/DetailedListMod.js